import { PageHeader } from '@/components/page-header';
import { BusinessProfileEditor } from '@/components/profile/BusinessProfileEditor';
import { RouteBreadcrumb } from '@/components/route-breadcrumb';

export default function SettingsProfilePage() {
  return (
    <div className="space-y-6">
      <RouteBreadcrumb items={[{ label: 'Settings', to: '/settings' }, { label: 'Profile Edit' }]} />

      <PageHeader
        title="Profile Edit"
        description="Update the personal details used across your HomeVein business account."
      />

      <BusinessProfileEditor
        title="Profile Details"
        description="Manage your personal information, contact details, and address."
        className="w-full max-w-none"
      />
    </div>
  );
}
